export default "__VITE_ASSET__01aeb270__"